var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row flex-center"},[_c('a',{staticClass:"logo-link",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":require("@/assets/img/new_kickbox_logo.svg")}})]),_c('img',{staticClass:"small-divider",attrs:{"src":require("@/assets/img/small_divider.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }